import "./App.css";
import Header from "./components/header/Header";
import Hero from "./components/hero/Hero";
import Footer from "./components/footer/Footer";

function App() {
  return (
    <div className="main">
      <Header />
      <Hero />
      <Footer />
    </div>
  );
}

export default App;
